import { storage } from './redux-storage';

export const translationPersistConfig = {
    key: 'translation',
    storage,
};
